import functions from './functions';

function readMoreButton(){

    if (functions.checkPage('archive-page')) {
        let sectionDesc = document.querySelector('.section__description');
        let readMoreBtn = document.querySelector('[data-read-more-btn]');
        if (sectionDesc.offsetHeight > 100) {
            readMoreBtn.addEventListener('click', e => {
                sectionDesc.classList.toggle('hide-desc');
                if (sectionDesc.classList.contains('hide-desc')) {
                    readMoreBtn.innerText = 'Czytaj więcej';
                } else {
                    readMoreBtn.innerText = 'Czytaj mniej';
                }
            });
        } else {
            readMoreBtn.classList.add('d-none');
        }
    }
}

export default {readMoreButton};


// WEBPACK FOOTER //
// ./src/scripts/category-page.js